import React, { FC, ReactNode, useMemo } from 'react';
import { ConnectionProvider } from '@/contexts/ConnectionContext';
import { WalletContextProvider } from '@/contexts/WalletContext';

interface WalletProviderProps {
  children: ReactNode;
}

export const WalletProvider: FC<WalletProviderProps> = ({ children }) => {
  const endpoint = useMemo(() => {
    const apiKey = import.meta.env.VITE_RPC_KEY;

    if (import.meta.env.VITE_NODE_ENV === 'production') {
      return `https://mainnet.helius-rpc.com/?api-key=${apiKey}`;
    } else {
      return `https://devnet.helius-rpc.com/?api-key=${apiKey}`;
    }
  }, []);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletContextProvider>
        {children}
      </WalletContextProvider>
    </ConnectionProvider>
  );
};
